export default "__VITE_ASSET__DPcc5HAg__"